module.exports = __webpack_public_path__ + "static/assets/70909a93adc6bc5d0f885a97cd8720ef.svg";